const baseURL = 'https://api.saamp.com'

export async function getMetals () {
  let response = await fetch(baseURL + '/metals')
  let data = await response.json()
  let rates = data.rates
  localStorage.setItem('metals', JSON.stringify(rates))
  return rates
}

export async function getCurrencies (symbols) {
  let response = await fetch(baseURL + '/currencies')
  let data = await response.json()
  let currencies = data.currencies
  currencies.USD = 1 // USD is the base currency

  if (symbols) {
    for (let symbol in currencies) {
      if (symbols.indexOf(symbol) === -1) {
        delete currencies[symbol]
      }
    }
  }

  return currencies
}

export function getCachedMetals () {
  let json = localStorage.getItem('metals')
  if (json) {
    localStorage.removeItem('metals')
    return JSON.parse(json)
  }
  return []
}

export default {
  getMetals: getMetals,
  getCurrencies: getCurrencies,
  getCachedMetals: getCachedMetals
}



// WEBPACK FOOTER //
// ./src/api.js